import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api, errMsg } from "@/lib/api";
import { Field, inputCls, Loading } from "@/components/common";
import { AuthCard } from "@/components/Brand";
import { Button } from "@/components/ui/button";

export default function ResetPassword() {
  const { token } = useParams();
  const { data, isLoading, error } = useQuery({ queryKey: ["reset", token], queryFn: () => api.get(`/auth/reset-password/${token}`).then((r) => r.data), retry: false });
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState("");
  const [busy, setBusy] = useState(false);
  if (isLoading) return <Loading full />;
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setErr("Passwords do not match");
    setBusy(true); setErr("");
    try { const { data: r } = await api.post(`/auth/reset-password/${token}`, { password: pw }); setDone(r.message); } catch (x) { setErr(errMsg(x)); } finally { setBusy(false); }
  };
  return (
    <AuthCard testId="reset-password-page">
      {error || !data ? (
        <div className="text-center" data-testid="reset-invalid">
          <h1 className="text-2xl font-bold">Reset link not valid</h1>
          <p className="text-sm text-slate-500 mt-2">{errMsg(error)}</p>
          <Button asChild className="btn-orange mt-5"><Link to="/forgot-password" data-testid="request-new-link">Request a new link</Link></Button>
        </div>
      ) : done ? (
        <div className="space-y-4" data-testid="reset-success">
          <h1 className="text-2xl font-bold">Password updated</h1>
          <p className="text-sm text-emerald-800 bg-emerald-50 rounded-lg px-3 py-3">{done}</p>
          <Button asChild className="w-full h-12 btn-orange text-base"><Link to="/login" data-testid="reset-go-login">Sign in</Link></Button>
        </div>
      ) : (
        <>
          <h1 className="text-3xl font-bold text-slate-900">Set a new password</h1>
          <p className="text-sm text-slate-500 mb-6">For <strong data-testid="reset-email">{data.email}</strong>. Any other signed-in sessions will be signed out.</p>
          <form onSubmit={submit} className="space-y-4">
            <input type="email" name="username" value={data.email || ""} readOnly autoComplete="username" className="hidden" tabIndex={-1} aria-hidden="true" />
            <Field label="New password" hint="At least 8 characters"><input type="password" name="new-password" className={inputCls} value={pw} onChange={(e) => setPw(e.target.value)} required minLength={8} autoComplete="new-password" data-testid="reset-password-input" /></Field>
            <Field label="Confirm new password"><input type="password" name="confirm-password" className={inputCls} value={pw2} onChange={(e) => setPw2(e.target.value)} required autoComplete="new-password" data-testid="reset-confirm-input" /></Field>
            {err && <p className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2" data-testid="reset-error">{err}</p>}
            <Button type="submit" disabled={busy} className="w-full h-12 btn-orange text-base" data-testid="reset-submit">{busy ? "Updating..." : "Update password"}</Button>
          </form>
        </>
      )}
    </AuthCard>
  );
}
